import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgGaruda from '../../../assets/images/pngwing.png';
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import DraftAppendix from "./DraftAppendix";
import Kemasan from "../../../utilities/Kemasan";

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 8,
        textAlign: "center",
        textDecoration: "underline"
    },
    headingIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
        marginBottom: 3
    },
    textRefNo: {
        fontSize: 7,
        textAlign: "right",
        marginRight: 75
    },
    textBox: {
        fontSize: 7
    },
    textBoxItalic: {
        fontSize: 7,
        fontFamily: "Roboto-Italic"
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableRowSign: {
        flexDirection: 'row',
        marginTop: 10
    },
    tableRowSignName: {
        flexDirection: 'row',
        marginTop: 40
    },
    tableCol1: {
        width: '30%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '5%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol3: {
        width: '60%',
        padding: 5,
        textAlign: 'left',
    },
    tableBox: {
        width: 'auto',
        display: 'table'
    },
    textEn: {
        fontSize: 8,
        textAlign: "left",
        textDecoration: "underline"
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "left",
    },
    textEnCenter: {
        fontSize: 8,
        textAlign: "center",
        textDecoration: "underline"
    },
    textInCenter: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
    },
    tableColBox1: {
        width: '45%',
        textAlign: 'left',
    },
    tableColBox2: {
        width: '5%',
        textAlign: 'left',
    },
    tableColBox3: {
        width: '50%',
        textAlign: 'left',
    },
    tableColBoxAtt: {
        width: '85%',
        textAlign: 'left',
    },
    tableColBoxSign1: {
        width: '10%',
        textAlign: 'left',
    },
    tableColBoxSign2: {
        width: '20%',
        textAlign: 'left',
    },
    tableColBoxSign3: {
        width: '30%',
        textAlign: 'left',
    },
    tableColBoxSign5: {
        width: '50%',
        textAlign: 'center',
    },
    tableboxSign: {
        width: 'auto',
        display: 'table',
        marginTop: 15
    }
})

const DraftA = ({ dataDisposisi, datappm, qrImage }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [totalJumlah, setTotalJumlah] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuProd, setPpmMutuProd] = useState([])
    const [ppmKemasan, setPpmKemasan] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const jsonPelBongkar = {
                jnsPelabuhan: "L",
                kodePelabuhan: datappm.pelabuhanBongkar
            };

            const results = await Promise.allSettled([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getNegaraById(datappm.negaraPartner),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.getTotalJumlahKomoditiPerSatuan(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuProdAll(datappm.nomorAju)
            ])

            const [
                resHc,
                resUpt,
                resNeg,
                resPelMuat,
                resPelBongkar,
                resDetil,
                resTotal,
                resKemasanAll,
                resKontainer,
                resMutu,
                resMutuProd
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            // Update state (batched oleh React)
            setDataHc(getData(resHc));
            setUpt(getData(resUpt, {}));
            setNegaraTujuan(getData(resNeg, {}))
            setPelMuat(getData(resPelMuat, {}));
            setPelBongkar(getData(resPelBongkar, {}));
            setPpmDetil(getData(resDetil));
            setTotalJumlah(getData(resTotal));
            setPpmKemasan(getData(resKemasanAll));
            setPpmKontainer(getData(resKontainer));
            setPpmMutu(getData(resMutu, {}));
            setPpmMutuProd(getData(resMutuProd));

        } catch (error) {
            console.error("Gagal memuat data:", error);
        }

    }, [datappm, dataDisposisi, transaksiService, masterService, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    return (
        <Document>
            <Page size="LEGAL" style={styles.page} wrap={false}>
                <View>
                    <Image style={styles.headingImg} src={imgGaruda} />
                    <Text style={styles.headingEn}>THE REPUBLIC OF INDONESIA</Text>
                    <Text style={styles.headingIn}>REPUBLIK INDONESIA</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>MINISTRY OF MARINE AFFAIRS AND FISHERIES</Text>
                    <Text style={styles.headingIn}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>HEALTH CERTIFICATE OF FISH AND FISHERY PRODUCT</Text>
                    <Text style={styles.headingIn}>SERTIFIKAT KESEHATAN PRODUK PERIKANAN</Text>
                </View>
                <View>
                    <Text style={styles.textRefNo}>Reference No: {dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textBox}>COUNTRY OF DISPATCH</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>THE REPUBLIC OF INDONESIA</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textBox}>COMPETENT AUTHORITY</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textBox}>INSPECTION AGENCY</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{upt !== null ? upt.nmInggris : '-'}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableBox}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>I.</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textEn}>PRODUCT IDENTIFICATION</Text>
                            <Text style={styles.textIn}>IDENTIFIKASI PRODUK</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>1</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>A. PRODUCT DESCRIPTION</Text>
                            <Text style={styles.textIn}>   DESKRIPSI PRODUK</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{ppmMutu !== null && ppmMutu !== undefined && ppmMutu.mutuDesk}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>B. SPECIES</Text>
                            <Text style={styles.textIn}>   SPESIES</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBoxItalic}>
                                {
                                    ppmDetil.length <= 3 ?
                                        (
                                            ppmDetil.map((detil, index) => {
                                                return (
                                                    <>{detil.namaLatin}{index < ppmDetil.length - 1 && '; '}</>
                                                )
                                            })
                                        ) :
                                        (
                                            'See Appendix'
                                        )
                                }
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>2.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>TYPE OF PROCESSING</Text>
                            <Text style={styles.textIn}>JENIS PENGOLAHAN</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{ppmMutu !== null && ppmMutu !== undefined && ppmMutu.mutuProses}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>3.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>TYPE AND NUMBER OF PACKAGING</Text>
                            <Text style={styles.textIn}>JENIS DAN JUMLAH KEMASAN</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>
                                {
                                    ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                        return (
                                            <>{kms.jumlah} <Kemasan id={kms.kodeKemasan} />{idx < ppmKemasan.length - 1 && '; '}</>
                                        )
                                    })
                                }
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>4.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>LOT IDENTIFICATION/PRODUCTION CODE</Text>
                            <Text style={styles.textIn}>KODE PRODUKSI</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>
                                {
                                    ppmMutuProd.length <= 3 ?
                                        ppmMutuProd.map((mutuProd, index) => {
                                            return (
                                                <>{mutuProd.mutuProdNo}{index < ppmMutuProd.length - 1 && '; '}</>
                                            )
                                        }) : 'See Appendix'
                                }
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>5.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>NET WEIGHT</Text>
                            <Text style={styles.textIn}>BERAT BERSIH</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>
                                {/* {dataHc !== null ? dataHc.netto : ''} kgs */}
                                {
                                    totalJumlah.map((detil, index) => {
                                        return (
                                            <>{detil.totalJumlah}{ ' ' }{detil.kodeSatuan.toUpperCase()}{index < totalJumlah.length - 1 && '; '}</>
                                        )
                                    })
                                }
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableBox}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>II.</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textEn}>ORIGIN OF PRODUCT</Text>
                            <Text style={styles.textIn}>ASAL PRODUK</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>1.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Name and Address Consignor</Text>
                            <Text style={styles.textIn}>Nama dan Alamat Pengirim</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                            <Text style={styles.textBox}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>2.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Name and Address Establishment</Text>
                            <Text style={styles.textIn}>Nama dan Alamat Unit Pengolahan Ikan</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                            <Text style={styles.textBox}>{dataHc !== null ? dataHc.alUpi : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>3.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Register Number/License</Text>
                            <Text style={styles.textIn}>Nomor Registrasi/Lisensi</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{ppmMutu !== null ? ppmMutu.upiRegNo : ''}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableBox}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>III.</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textEn}>DESTINATION OF PRODUCT</Text>
                            <Text style={styles.textIn}>TUJUAN PRODUK</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>1.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>The fishery products are to be dispatch from</Text>
                            <Text style={styles.textIn}>Produk Perikanan dikirim dari</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{pelMuat !== null ? pelMuat.uraianPelabuhan : '-'}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>2.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>To</Text>
                            <Text style={styles.textIn}>Ke</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : '-'}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>3.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>By the following means of transport</Text>
                            <Text style={styles.textIn}>Dengan menggunakan cara transportasi</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmTrans : ''} / {dataHc !== null ? dataHc.noFlight : ''}</Text>
                            <Text style={styles.textBox}>
                                {
                                    ppmKontainer !== undefined && ppmKontainer !== null &&
                                    ppmKontainer.map((kont, index) => {
                                        return (
                                            <>
                                                {kont.nomor} / {kont.nomorSegel}{index < ppmKontainer.length - 1 && '; '}
                                            </>
                                        )
                                    })
                                }
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>4.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Temperature required during storage and transportation</Text>
                            <Text style={styles.textIn}>Suhu selama penyimpanan dan transportasi</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{ppmMutu !== null ? ppmMutu.mutuTemp : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>5.</Text>
                        </View>
                        <View style={styles.tableColBox1}>
                            <Text style={styles.textEn}>Name and Address of Consigne</Text>
                            <Text style={styles.textIn}>Nama dan Alamat Penerima</Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={[styles.tableCol3, { padding: 0 }]}>
                            <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                            <Text style={styles.textBox}>{dataHc !== null ? dataHc.alPenerima : ''} {negaraTujuan !== null ? negaraTujuan.uraianNegara : ''}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableBox}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>IV.</Text>
                        </View>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textEn}>ATTESTATION</Text>
                            <Text style={styles.textIn}>PERNYATAAN</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>1.</Text>
                        </View>
                        <View style={styles.tableColBoxAtt}>
                            <Text style={styles.textEn}>The products described above originate from (an) approved establishment (s) and</Text>
                            <Text style={styles.textIn}>Produk yang diuraikan diatas berasal dari unit pengolahan ikan yang sudah diakui dan</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBox2}>
                            <Text style={styles.textBox}>2.</Text>
                        </View>
                        <View style={styles.tableColBoxAtt}>
                            <Text style={styles.textEn}>have been handled, prepared or processed, identified, stored and transported under a HACCP-Based Integrated Quality Management Programe, consistently in accordance with the requirements</Text>
                            <Text style={styles.textIn}>telah ditangani, disiapkan, diolah, diidentifikasi, disimpan, dan didistribusikan berdasarkan penerapan Program Manajemen Mutu Terpadu berdasarkan HACCP yang telah diterapkan secara konsisten sesuai dengan persyaratan</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableboxSign}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textEn}>Done</Text>
                            <Text style={styles.textIn}>Dilaksanakan</Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}>{upt !== null ? upt.kota : ''}</Text>
                        </View>
                        <View style={styles.tableColBoxSign1}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textEn}>On</Text>
                            <Text style={styles.textIn}>Pada</Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxAtt}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRowSign}>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign5}>
                            <Text style={styles.textEnCenter}>Signature of the official inspector</Text>
                            <Text style={styles.textInCenter}>Tanda tangan Inspektur Mutu</Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRowSignName}>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign5}>
                            <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                            <Text style={styles.textEnCenter}>Name in capital letter</Text>
                            <Text style={styles.textInCenter}>Nama (dengan huruf besar)</Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                </View>
            </Page>
            {
                (ppmDetil.length > 3 || ppmMutuProd.length > 3) &&
                <>
                    <DraftAppendix ppmdetil={ppmDetil} datahc={dataHc} upt={upt} dataDisposisi={dataDisposisi} qrImage={qrImage} ppmMutuProd={ppmMutuProd} finalFor="2" />
                </>
            }
        </Document>
    )
}

export default DraftA